import { Flex } from "../../components/Flex";
import { Slider } from "../../components/Slider";
import { Image } from "../../components/Image";
import success from "../../assets/card-success-icon.svg";
import inReview from "../../assets/card-in-review-icon.svg";
import { useIndividualCheck } from "../../data/useIndividualCheck";
import { Box } from "../../components/Box";
import { H3 } from "../../components/Heading";
import { Loader } from "../../components/Loader";
import { TableBody } from "../../components/Table/TableBody";
import { TableCell } from "../../components/Table/TableCell";
import { TableHead } from "../../components/Table/TableHead";
import { TableRow } from "../../components/Table/TableRow";
import {
  IndividualCheckStatus,
  CheckStatusEnum,
} from "../../context/MandateStatusContext";
import {
  CheckContainer,
  CheckParagraph,
  CheckHeading,
  CheckTable,
  CheckTableHeaderRow,
  CheckTableCell,
  CheckTitle,
  Section,
} from "./CheckStyledComponents";
import { ManualAcceptReject } from "./ManualAcceptReject";
import { IndividualChecksMap } from "./helper";
import { CheckResults } from "./CheckResults";
import { CheckFields } from "./CheckFields";
import { GrayCard } from "../../components/Card";
import { Paragraph } from "../../components/Paragraph";
import { DateTime } from "luxon";
import { ApprovalComment } from "./approvalComment";
import { useIndividual } from "../../data/useIndividual";
import { useParams } from "react-router-dom";

export const BankDetailsCheck = (props) => {
  const params = useParams();

  const { isOpen, onRequestClose, id, useSlider = true } = props;

  const { data: individualCheckData, isLoading: isLoadingIndividualCheck } =
    useIndividualCheck(id);

  const { data: individualData } = useIndividual(params.id);

  const individual = individualData?.data;

  const instance = individualCheckData?.data?.instance;

  const content = (
    <CheckContainer>
      <Flex justifyContent="space-between">
        <CheckTitle>
          {IndividualChecksMap.bank_account_details_check.title}
        </CheckTitle>

        {individualCheckData?.data?.status?.status ===
          CheckStatusEnum.Review && (
          <ManualAcceptReject
            id={id}
            title={IndividualChecksMap.bank_account_details_check.title}
            isMonitoring={false}
          ></ManualAcceptReject>
        )}
      </Flex>
      {individualCheckData?.data?.status?.status && (
        <CheckResults
          status={individualCheckData?.data?.status?.status}
        ></CheckResults>
      )}

      {instance && instance?.approval_comment && (
        <ApprovalComment
          data={instance?.approval_comment}
          status={individualCheckData?.data?.status?.status}
        ></ApprovalComment>
      )}

      <CheckFields
        individual_checkfield_result={
          individualCheckData?.data?.individual_checkfield_result
        }
      ></CheckFields>

      {instance && (
        <Section>
          <Flex gap="16" alignItems={"center"} mb={2}>
            <Box>
              <Image
                src={
                  instance?.header?.status === IndividualCheckStatus.Passed
                    ? success
                    : inReview
                }
                alt="status icon"
                height="20px"
                width="auto"
                mr={1}
              />
            </Box>

            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              width={"90%"}
            >
              <Box flex={1}>
                <H3>
                  Bank Account {instance?.header?.status}
                  {instance?.header?.status !==
                    IndividualCheckStatus.Passed && (
                    <>
                      &nbsp;-&nbsp;
                      {instance?.header?.status}
                    </>
                  )}
                </H3>
              </Box>
              <Box flex={1}>
                {" "}
                <Paragraph>
                  <strong>Status:</strong>
                  {instance?.detail?.uk_account
                    ? " UK bank account"
                    : " Non-UK bank account"}
                </Paragraph>
              </Box>
            </Flex>
          </Flex>
          <Flex justifyContent={"space-between"}>
            <Box flex={1}>
              <H3>Bank account information:</H3>

              {instance?.detail && (
                <Box flex={1.4}>
                  {instance?.detail ? (
                    <Box>
                      <Flex gap="12" alignItems={"center"}>
                        <Paragraph>Name on account:</Paragraph>
                        <Paragraph color="gray.40">
                          {instance?.detail?.name_on_account && (
                            <span>
                              {instance?.detail?.name_on_account}
                              &nbsp;
                            </span>
                          )}
                        </Paragraph>
                      </Flex>
                      <Flex gap="12" alignItems={"center"}>
                        <Paragraph>Account number: </Paragraph>
                        <Paragraph color="gray.40">
                          {instance?.detail?.account_number && (
                            <span>
                              {instance?.detail?.account_number}
                              &nbsp;
                            </span>
                          )}
                        </Paragraph>
                      </Flex>
                      {instance?.detail?.iban && (
                        <Flex gap="12" alignItems={"center"}>
                          <Paragraph>IBAN:</Paragraph>
                          <Paragraph color="gray.40">
                            {instance?.detail?.iban && (
                              <span>
                                {instance?.detail?.iban}
                                &nbsp;
                              </span>
                            )}
                          </Paragraph>
                        </Flex>
                      )}
                      {instance?.detail?.sort_code && (
                        <Flex gap="12" alignItems={"center"}>
                          {instance?.detail?.uk_account ? (
                            <Paragraph>Sort code:</Paragraph>
                          ) : (
                            <Paragraph>Swift/BIC code:</Paragraph>
                          )}
                          <Paragraph color="gray.40">
                            {instance?.detail?.sort_code && (
                              <span>
                                {instance?.detail?.sort_code}
                                &nbsp;
                              </span>
                            )}
                          </Paragraph>
                        </Flex>
                      )}
                    </Box>
                  ) : (
                    "-"
                  )}
                </Box>
              )}
            </Box>
            <Box flex={1}>
              <H3>Personal information:</H3>

              <Box>
                <Flex gap="12" alignItems={"center"}>
                  <Paragraph>First name:</Paragraph>
                  <Paragraph color="gray.40">
                    {individual?.personal_detail?.first_name
                      ? individual?.personal_detail?.first_name
                      : "-"}
                    &nbsp;
                  </Paragraph>
                </Flex>
                <Flex gap="12" alignItems={"center"}>
                  <Paragraph>Middle name:</Paragraph>
                  <Paragraph color="gray.40">
                    {individual?.personal_detail?.middle_name
                      ? individual?.personal_detail?.middle_name
                      : "-"}
                    &nbsp;
                  </Paragraph>
                </Flex>
                <Flex gap="12" alignItems={"center"}>
                  <Paragraph>Last name:</Paragraph>
                  <Paragraph color="gray.40">
                    {individual?.personal_detail?.last_name
                      ? individual?.personal_detail?.last_name
                      : "-"}
                    &nbsp;
                  </Paragraph>
                </Flex>

                <Flex gap="12" alignItems={"center"}>
                  <Paragraph width={95}>Address:</Paragraph>
                  <Paragraph color="gray.40">
                    {individual?.address ? (
                      <>
                        {individual?.address?.flat_appartment_subbuilding && (
                          <span>
                            {individual?.address?.flat_appartment_subbuilding}
                            &nbsp;
                          </span>
                        )}
                        {individual?.address?.building_number && (
                          <span>
                            {individual?.address?.building_number}
                            &nbsp;
                          </span>
                        )}
                        {individual?.address?.building_name && (
                          <span>
                            {individual?.address?.building_name}
                            &nbsp;
                          </span>
                        )}
                        {individual?.address?.road_street},&nbsp;
                        {individual?.address?.town_city},&nbsp;
                        {individual?.address?.district},&nbsp;
                        {individual?.address?.post_zip_code},&nbsp;
                        {individual?.address?.country_name}
                      </>
                    ) : (
                      "-"
                    )}
                  </Paragraph>
                </Flex>
              </Box>
            </Box>
          </Flex>
        </Section>
      )}

      {instance && (
        <Section>
          <Box mb={2}>
            <CheckHeading>Details:</CheckHeading>
            <CheckTable>
              <TableHead></TableHead>
              <TableBody>
                <CheckTableHeaderRow>
                  <CheckTableCell>Result</CheckTableCell>
                  <CheckTableCell>Key</CheckTableCell>
                  <CheckTableCell>Reason</CheckTableCell>
                </CheckTableHeaderRow>

                {instance?.results[0]?.reasons.map(
                  ({ status, key, reason }, i) => (
                    <TableRow key={i}>
                      <TableCell
                        width="15%"
                        style={{ textTransform: "uppercase" }}
                        fontWeight="500"
                        color="gray.80"
                        borderBottom="none"
                      >
                        <Flex gap="8">
                          <Image
                            src={
                              status === IndividualCheckStatus.Passed
                                ? success
                                : inReview
                            }
                            alt="status icon"
                            height="20px"
                            width="auto"
                            mr={1}
                          />
                          {status}
                        </Flex>
                      </TableCell>
                      <TableCell
                        width="15%"
                        color="gray.60"
                        borderBottom="none"
                      >
                        {key}
                      </TableCell>
                      <TableCell color="gray.60" borderBottom="none">
                        {reason}
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </CheckTable>
          </Box>
        </Section>
      )}

      {instance && instance?.bank_check && (
        <Section>
          <Flex justifyContent="space-between" mb={2}>
            <Box>
              <H3>
                Bank Account
                {instance?.bank_check?.status !==
                  IndividualCheckStatus.Passed && (
                  <>
                    &nbsp;-&nbsp;
                    {instance?.bank_check?.status}
                  </>
                )}
              </H3>
            </Box>
            <Box>
              <Image
                src={
                  instance?.bank_check?.status === IndividualCheckStatus.Passed
                    ? success
                    : inReview
                }
                alt="status icon"
                height="20px"
                width="auto"
                mr={1}
              />
            </Box>
          </Flex>

          {instance?.bank_check?.status !== IndividualCheckStatus.Passed && (
            <>
              <Flex mb={2} alignItems="center">
                <CheckHeading mr={1}>Reason:</CheckHeading>
                <CheckParagraph>
                  {instance?.bank_check?.reason
                    ? instance?.bank_check?.reason
                    : "-"}
                </CheckParagraph>
              </Flex>

              <Box mb={2}>
                <CheckHeading>Details:</CheckHeading>
                <CheckTable>
                  <TableHead></TableHead>
                  <TableBody>
                    <CheckTableHeaderRow>
                      <CheckTableCell>Result</CheckTableCell>
                      <CheckTableCell>Code</CheckTableCell>
                      <CheckTableCell>Reason</CheckTableCell>
                    </CheckTableHeaderRow>
                    {instance?.bank_check?.details?.map(
                      ({ status, code, reason }, i) => (
                        <TableRow key={i}>
                          <TableCell
                            width="15%"
                            style={{ textTransform: "uppercase" }}
                            fontWeight="500"
                            color="gray.80"
                            borderBottom="none"
                          >
                            <Flex gap="8">
                              <Image
                                src={
                                  status === IndividualCheckStatus.Passed
                                    ? success
                                    : inReview
                                }
                                alt="status icon"
                                height="20px"
                                width="auto"
                                mr={1}
                              />
                              {status}
                            </Flex>
                          </TableCell>
                          <TableCell
                            width="15%"
                            color="gray.60"
                            borderBottom="none"
                          >
                            {code}
                          </TableCell>
                          <TableCell color="gray.60" borderBottom="none">
                            {reason}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </CheckTable>
              </Box>
            </>
          )}

          {instance?.bank_check?.status === IndividualCheckStatus.Passed && (
            <>
              <Flex alignItems="center" mb={2}>
                <CheckHeading>Result: &nbsp;</CheckHeading>
                <CheckParagraph>PASSED</CheckParagraph>
              </Flex>
              <GrayCard mx="0">
                <Paragraph fontWeight="600" m="0">
                  Supplied details did not match
                </Paragraph>
              </GrayCard>
            </>
          )}
        </Section>
      )}

      {instance && instance?.sanctions_check && (
        <Section>
          <Flex justifyContent="space-between" mb={2}>
            <Box>
              <H3>
                Sanctions Check
                {instance?.sanctions_check?.status !==
                  IndividualCheckStatus.Passed && (
                  <>
                    &nbsp;-&nbsp;
                    {instance?.sanctions_check?.status}
                  </>
                )}
              </H3>
            </Box>
            <Box>
              <Image
                src={
                  instance?.sanctions_check?.status ===
                  IndividualCheckStatus.Passed
                    ? success
                    : inReview
                }
                alt="status icon"
                height="20px"
                width="auto"
                mr={1}
              />
            </Box>
          </Flex>

          {instance?.sanctions_check?.status !== IndividualCheckStatus.Passed &&
            instance?.sanctions_check?.details &&
            instance?.sanctions_check?.details.length > 0 && (
              <>
                <Box mb={2}>
                  <CheckHeading>Details:</CheckHeading>
                </Box>
                {instance?.sanctions_check?.details.map((detail, index) => (
                  <GrayCard key={index} mx="0px">
                    <H3
                      mb={3}
                      py={2}
                      borderBottom="1px solid"
                      borderBottomColor="gray.30"
                    >
                      {detail?.status}
                    </H3>
                    <CheckHeading color="gray.60" fontWeight="500">
                      Reason
                    </CheckHeading>
                    <Paragraph mt={1} mb={2} color="gray.80" fontWeight="500">
                      {detail?.reason ? detail?.reason : "-"}
                    </Paragraph>

                    <Flex justifyContent="space-between">
                      <Box flex={1}>
                        <CheckHeading color="gray.60" fontWeight="500">
                          Source Origin
                        </CheckHeading>
                        <Paragraph
                          mt={1}
                          mb={2}
                          color="gray.80"
                          fontWeight="500"
                        >
                          {detail?.source_origin_name
                            ? detail?.source_origin_name
                            : "-"}
                        </Paragraph>
                      </Box>

                      <Box flex={1}>
                        <CheckHeading color="gray.60" fontWeight="500">
                          Source Name
                        </CheckHeading>
                        <Paragraph
                          mb={2}
                          mt={1}
                          color="gray.80"
                          fontWeight="500"
                        >
                          {detail?.source_name ? detail?.source_name : "-"}
                        </Paragraph>
                      </Box>
                    </Flex>

                    <Flex justifyContent="space-between">
                      <Box flex={1}>
                        <CheckHeading color="gray.60" fontWeight="500">
                          Title
                        </CheckHeading>
                        <Paragraph
                          mb={2}
                          mt={1}
                          color="gray.80"
                          fontWeight="500"
                        >
                          {detail?.title ? detail?.title : "-"}
                        </Paragraph>
                      </Box>

                      <Box flex={1}>
                        <CheckHeading color="gray.60" fontWeight="500">
                          Date
                        </CheckHeading>
                        <Paragraph
                          mb={2}
                          mt={1}
                          color="gray.80"
                          fontWeight="500"
                        >
                          {detail?.date
                            ? DateTime.fromISO(detail?.date).toFormat(
                                "dd/MM/yyyy"
                              )
                            : "-"}
                        </Paragraph>
                      </Box>
                    </Flex>

                    <Box>
                      <CheckHeading color="gray.60" fontWeight="500">
                        URL
                      </CheckHeading>
                      <Paragraph mb={2} mt={1} color="gray.80" fontWeight="500">
                        {detail?.url ? detail?.url : "-"}
                      </Paragraph>
                    </Box>
                  </GrayCard>
                ))}
              </>
            )}

          {instance?.sanctions_check?.status ===
            IndividualCheckStatus.Passed && (
            <>
              <Flex alignItems="center" mb={2}>
                <CheckHeading>Result: &nbsp;</CheckHeading>
                <CheckParagraph>PASSED</CheckParagraph>
              </Flex>
              <GrayCard mx="0">
                <Paragraph fontWeight="600" m="0">
                  Supplied details did not match
                </Paragraph>
              </GrayCard>
            </>
          )}
        </Section>
      )}
    </CheckContainer>
  );

  return (
    <>
      {isLoadingIndividualCheck ? (
        <Flex justifyContent="center" alignItems="center" minHeight="60vh">
          <Loader />
        </Flex>
      ) : useSlider ? (
        <Slider
          isOpen={isOpen}
          onRequestClose={() => onRequestClose(false)}
          width="70%"
        >
          {content}
        </Slider>
      ) : (
        content
      )}
    </>
  );
};
